/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { ApiRequestDto } from '../model/apiRequestDto';
import { MedicationSummaryAdverseDrugReactionOrder } from '../model/medicationSummaryAdverseDrugReactionOrder';
import { MedicationSummaryMedicationSummaryOrder } from '../model/medicationSummaryMedicationSummaryOrder';
import { MedicationSummaryNarrowTherapeuticIndex } from '../model/medicationSummaryNarrowTherapeuticIndex';
import { MedicationSummarySlidingScaleInsulin } from '../model/medicationSummarySlidingScaleInsulin';
import { MedicationSummarySpecialRequirementsMedication } from '../model/medicationSummarySpecialRequirementsMedication';
import { ResidentCountResult } from '../model/residentCountResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MedicationSummaryService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns raw data for the Adverse Drug Reaction Order (ADR) grid. the data is not aggregated.
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetAdverseDrugReactionOrders
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAdverseDrugReactionOrders(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryAdverseDrugReactionOrder>;
    public medicationSummaryGetAdverseDrugReactionOrders(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryAdverseDrugReactionOrder>>;
    public medicationSummaryGetAdverseDrugReactionOrders(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryAdverseDrugReactionOrder>>;
    public medicationSummaryGetAdverseDrugReactionOrders(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAdverseDrugReactionOrders.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryAdverseDrugReactionOrder>(`${this.basePath}/api/MedicationSummary/GetAdverseDrugReactionOrders`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Adverse Drug Reaction Order (ADR) groups, top 4 with the fifth group being \&quot;other\&quot;
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of ADR orders that facility has that belongs to that drug group.          Sample Call      http://URL/api/MedicationSummary/GetAdverseDrugReactionOrderByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAdverseDrugReactionOrdersByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAdverseDrugReactionOrdersByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAdverseDrugReactionOrdersByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Adverse Drug Reaction Order (ADR) grouped by facility
     * Queries ADR medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount      Sample Call      http://URL/api/MedicationSummary/GetAdverseDrugReactionOrdersByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAdverseDrugReactionOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAdverseDrugReactionOrdersByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAdverseDrugReactionOrdersByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Adverse Drug Reaction Order (ADR) grouped by facility
     * Queries Adverse Drug Reaction medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetAdverseDrugReactionOrdersByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAdverseDrugReactionOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAdverseDrugReactionOrdersByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAdverseDrugReactionOrdersByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAdverseDrugReactionOrdersByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with Adverse Drug Reaction orders.
     * Sample Call  http://URL/api/MedicationSummary/GetAdverseDrugReactionOrdersPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAdverseDrugReactionOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public medicationSummaryGetAdverseDrugReactionOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public medicationSummaryGetAdverseDrugReactionOrdersPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public medicationSummaryGetAdverseDrugReactionOrdersPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAdverseDrugReactionOrdersPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/MedicationSummary/GetAdverseDrugReactionOrdersPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns raw data for the Anticoagulant medication grid. the data is not aggregated.
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetAnticoagulantMedications
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAnticoagulantMedications(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryMedicationSummaryOrder>;
    public medicationSummaryGetAnticoagulantMedications(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryMedicationSummaryOrder>>;
    public medicationSummaryGetAnticoagulantMedications(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryMedicationSummaryOrder>>;
    public medicationSummaryGetAnticoagulantMedications(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAnticoagulantMedications.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryMedicationSummaryOrder>(`${this.basePath}/api/MedicationSummary/GetAnticoagulantMedications`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Anticoagulant medication groups, top 4 with the fifth group being \&quot;other\&quot;
     * Displays top 4 drug groups with the fifth group being \&quot;other\&quot; if a single facility is passed.     If multiple facilities are passed in, the top drug groups are return.  Within each drug group, the facilities making up the top  5 (with #5 being other group if more than 5 facilities are passed in) will be display.  Item count under each facility is the  count of anticoagulant medications that facility has that belongs to that drug group.          Sample Call      http://URL/api/MedicationSummary/GetAnticoagulantMedicationsByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAnticoagulantMedicationsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAnticoagulantMedicationsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAnticoagulantMedicationsByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAnticoagulantMedicationsByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Anticoagulant medications grouped by facility
     * Queries Anticoagulant medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetAnticoagulantMedicationsByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAnticoagulantMedicationsByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAnticoagulantMedicationsByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAnticoagulantMedicationsByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAnticoagulantMedicationsByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Anticoagulant medication grouped by prescriber
     * Queries Anticoagulant medications and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetAnticoagulantMedicationsByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAnticoagulantMedicationsByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetAnticoagulantMedicationsByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetAnticoagulantMedicationsByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAnticoagulantMedicationsByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetAnticoagulantMedicationsByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with Anticoagulant medications.
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetAnticoagulantMedicationsPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetAnticoagulantMedicationsPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public medicationSummaryGetAnticoagulantMedicationsPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public medicationSummaryGetAnticoagulantMedicationsPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public medicationSummaryGetAnticoagulantMedicationsPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetAnticoagulantMedicationsPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/MedicationSummary/GetAnticoagulantMedicationsPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns raw data for Narrow Therapeutic Index (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetNarrowTherapeuticIndex
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetNarrowTherapeuticIndex(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryNarrowTherapeuticIndex>;
    public medicationSummaryGetNarrowTherapeuticIndex(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryNarrowTherapeuticIndex>>;
    public medicationSummaryGetNarrowTherapeuticIndex(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryNarrowTherapeuticIndex>>;
    public medicationSummaryGetNarrowTherapeuticIndex(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetNarrowTherapeuticIndex.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryNarrowTherapeuticIndex>(`${this.basePath}/api/MedicationSummary/GetNarrowTherapeuticIndex`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Narrow Therapeutic Index By Drug Group
     * Queries Narrow Therapeutic Index and returns groupings by grug group and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetNarrowTherapeuticIndexByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetNarrowTherapeuticIndexByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetNarrowTherapeuticIndexByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetNarrowTherapeuticIndexByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetNarrowTherapeuticIndexByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Narrow Therapeutic Index By Facility
     * Queries Narrow Therapeutic Index and returns groupings by facility and then within each facility by drug group.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetNarrowTherapeuticIndexByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetNarrowTherapeuticIndexByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetNarrowTherapeuticIndexByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetNarrowTherapeuticIndexByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetNarrowTherapeuticIndexByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Narrow Therapeutic Index By Prescriber
     * Queries Narrow Therapeutic Index and returns groupings by Prescriber and then within each facility.    Count of each group is stored in ItemCount        Sample Call      http://URL/api/MedicationSummary/GetNarrowTherapeuticIndexByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetNarrowTherapeuticIndexByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetNarrowTherapeuticIndexByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetNarrowTherapeuticIndexByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetNarrowTherapeuticIndexByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetNarrowTherapeuticIndexByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with Narrow Therapeutic Index medications
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetNarrowTherapeuticIndexPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetNarrowTherapeuticIndexPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public medicationSummaryGetNarrowTherapeuticIndexPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public medicationSummaryGetNarrowTherapeuticIndexPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public medicationSummaryGetNarrowTherapeuticIndexPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetNarrowTherapeuticIndexPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/MedicationSummary/GetNarrowTherapeuticIndexPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns sliding scale insulin (SSI) grouped by drug name
     * Top 4 with the fifth group being \&quot;other\&quot;        Sample Call      http://URL/api/MedicationSummary/GetSlidingScaleInsulinByDrugName
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSlidingScaleInsulinByDrugName(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSlidingScaleInsulinByDrugName(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByDrugName(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByDrugName(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSlidingScaleInsulinByDrugName.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSlidingScaleInsulinByDrugName`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns sliding scale insulin (SSI) grouped by facility
     * Groups sliding scale insulin orders by facility and then by drug name.  Top 4 groups with the fifth group being \&quot;other\&quot;        Sample Call      http://URL/api/MedicationSummary/GetSlidingScaleInsulinByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSlidingScaleInsulinByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSlidingScaleInsulinByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSlidingScaleInsulinByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSlidingScaleInsulinByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns sliding scale insulin (SSI) grouped by prescriber.
     * Groups sliding scale insulin orders by prescriber and then by drug name.  Top 4 groups with the fifth group being \&quot;other\&quot;.  If multiple facilities are selected the Sliding Scale Insulins by facilities call should be used instead (GetSlidingScaleInsulinByFacility)        Sample Call      http://URL/api/MedicationSummary/GetSlidingScaleInsulinByPrescriber?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgUnit&#x3D;590
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational unit to get data for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSlidingScaleInsulinByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSlidingScaleInsulinByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByPrescriber(startDate: string, endDate: string, orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSlidingScaleInsulinByPrescriber(startDate: string, endDate: string, orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling medicationSummaryGetSlidingScaleInsulinByPrescriber.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling medicationSummaryGetSlidingScaleInsulinByPrescriber.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling medicationSummaryGetSlidingScaleInsulinByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSlidingScaleInsulinByPrescriber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Sliding Scale Insulin (SSI) raw data
     * This data will be use to populate grids        Sample Call      http://URL/api/MedicationSummary/GetSlidingScaleInsulinData
     * @param requestParameters Contains request parameters: orgList, startDate, endDate, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSlidingScaleInsulinData(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummarySlidingScaleInsulin>;
    public medicationSummaryGetSlidingScaleInsulinData(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummarySlidingScaleInsulin>>;
    public medicationSummaryGetSlidingScaleInsulinData(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummarySlidingScaleInsulin>>;
    public medicationSummaryGetSlidingScaleInsulinData(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSlidingScaleInsulinData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummarySlidingScaleInsulin>(`${this.basePath}/api/MedicationSummary/GetSlidingScaleInsulinData`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with Sliding Scale Insulin medications.
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetSlidingScaleInsulinPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSlidingScaleInsulinPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public medicationSummaryGetSlidingScaleInsulinPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public medicationSummaryGetSlidingScaleInsulinPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public medicationSummaryGetSlidingScaleInsulinPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSlidingScaleInsulinPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/MedicationSummary/GetSlidingScaleInsulinPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Special Requirements Medication Groups By Drug Group
     * Top 4 with the fifth group being \&quot;other\&quot;        Sample Call      http://URL/api/MedicationSummary/GetSpecialRequirementsMedicationByDrugGroup
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSpecialRequirementsMedicationByDrugGroup(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSpecialRequirementsMedicationByDrugGroup(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByDrugGroup(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByDrugGroup(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSpecialRequirementsMedicationByDrugGroup.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSpecialRequirementsMedicationByDrugGroup`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Special Requirements Medication Groups By Facility
     * Top 4 with the fifth group being \&quot;other\&quot;        Sample Call      http://URL/api/MedicationSummary/GetSpecialRequirementsMedicationByFacility
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSpecialRequirementsMedicationByFacility(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSpecialRequirementsMedicationByFacility(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByFacility(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByFacility(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSpecialRequirementsMedicationByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSpecialRequirementsMedicationByFacility`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Special Requirements Medication Groups By Prescriber
     * Top 4 with the fifth group being \&quot;other\&quot;        Sample Call      http://URL/api/MedicationSummary/GetSpecialRequirementsMedicationByPrescriber
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSpecialRequirementsMedicationByPrescriber(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public medicationSummaryGetSpecialRequirementsMedicationByPrescriber(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByPrescriber(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public medicationSummaryGetSpecialRequirementsMedicationByPrescriber(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSpecialRequirementsMedicationByPrescriber.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AggregateData>>(`${this.basePath}/api/MedicationSummary/GetSpecialRequirementsMedicationByPrescriber`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Special Requirements Medication raw data
     * This data will be use to populate grids        Sample Call      http://URL/api/MedicationSummary/SpecialRequirementsMedication
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSpecialRequirementsMedicationData(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummarySpecialRequirementsMedication>;
    public medicationSummaryGetSpecialRequirementsMedicationData(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummarySpecialRequirementsMedication>>;
    public medicationSummaryGetSpecialRequirementsMedicationData(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummarySpecialRequirementsMedication>>;
    public medicationSummaryGetSpecialRequirementsMedicationData(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSpecialRequirementsMedicationData.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummarySpecialRequirementsMedication>(`${this.basePath}/api/MedicationSummary/GetSpecialRequirementsMedicationData`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns percentage of residents with Special Requirements Medication
     * Data in this call is not aggregated.        Sample Call      http://URL/api/MedicationSummary/GetSpecialRequirementsMedicationPercentage
     * @param requestParameters Contains request parameters: orgList, startDate, endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public medicationSummaryGetSpecialRequirementsMedicationPercentage(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ResidentCountResult>;
    public medicationSummaryGetSpecialRequirementsMedicationPercentage(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResidentCountResult>>;
    public medicationSummaryGetSpecialRequirementsMedicationPercentage(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResidentCountResult>>;
    public medicationSummaryGetSpecialRequirementsMedicationPercentage(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling medicationSummaryGetSpecialRequirementsMedicationPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResidentCountResult>(`${this.basePath}/api/MedicationSummary/GetSpecialRequirementsMedicationPercentage`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
